import { useParams } from "@tanstack/react-router";
import { ReviewReport } from "@/components/reviews/ReviewReport";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";
import { useReviewReport } from "@/hooks/use-review-report";

/** One person's review, read as a whole. See `ReviewReport`. */
export function ReviewReportPage() {
  const { reviewId } = useParams({ from: "/dashboard/reviews/reports/$reviewId" });
  const { data } = useReviewReport(reviewId);

  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: data?.subjectName ?? "Review" },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title={data?.subjectName ?? "Review"}
        description={
          data
            ? `${data.cycleName} · ${data.roleName}${data.roleLevelName ? ` · ${data.roleLevelName}` : ""}`
            : "Every rating side by side, against the standard for the role."
        }
      />
      <ReviewReport reviewId={reviewId} />
    </div>
  );
}
